export const disabledTextStyle = {
    // fontSize: '0.9rem',
    // color: '#BDBDBD',
    fontWeight: 'normal',
    backgroundColor: '#998f8fff'
};

export const highlLightedTextStyle = {
    color: '#003C59',
    textAlign: 'center',
    fontSize: '0.9rem',
    lineHeight: 1.6
};